import axios from "../config/axios-chatbot";

// Statistics per usermanagement project (chatbot backend, /api/project-statistic/{projectId}).
// filters: {subProjectId, projectVersionType, segment, conversationType}, all optional and matched exactly;
// blank values are dropped so they match everything.
const toParams = (filters = {}, extra = {}) => Object.fromEntries(
  Object.entries({...filters, ...extra}).filter(([, value]) => value !== undefined && value !== null && value !== "")
);

const base = (projectId) => `/api/project-statistic/${encodeURIComponent(projectId)}`;

// The backend requires X-Project-Id on every call. Inside a project's pages it is a default header (setBaseURL),
// but these calls are also made outside them (e.g. the projects table), so each request sends it itself.
const headers = (projectId) => ({"X-Project-Id": projectId});

// ACTIVE_CALLS (peak concurrent calls) is also served by getResponseTime, per project only (filters are ignored)
export const PROJECT_RESPONSE_TIME_TYPES = ["CHATBOT", "TEXT_TO_SPEECH", "SPEECH_TO_TEXT"];

export const ProjectStatisticRepository = {
  // type: CHATBOT | TEXT_TO_SPEECH | SPEECH_TO_TEXT, period: MINUTES | HOURLY | DAYS, start/end: local date-times
  // baseURL: the project's own backend, when called outside its pages (else the current axios base URL)
  getResponseTime: ({projectId, type, period, start, end, filters, signal, baseURL}) =>
    axios.get(`${base(projectId)}/response-time`, {
      params: toParams(filters, {type, period, start, end}), headers: headers(projectId), signal,
      ...(baseURL ? {baseURL} : {}),
    }),
  // Number of the project's conversations active right now (plain integer)
  getActiveCalls: ({projectId, filters, signal}) =>
    axios.get(`${base(projectId)}/active-calls`, {params: toParams(filters), headers: headers(projectId), signal}),
  // The same count split per sub project and version type: {filter, total, items: [{subProjectId, projectVersionType, count}]}
  getActiveCallsBreakdown: ({projectId, filters, signal}) =>
    axios.get(`${base(projectId)}/active-calls/breakdown`, {params: toParams(filters), headers: headers(projectId), signal}),
  getTags: ({projectId, period, start, end, filters, signal}) =>
    axios.get(`${base(projectId)}/tags`, {params: toParams(filters, {period, start, end}), headers: headers(projectId), signal}),
  // start/end: ISO dates (YYYY-MM-DD), both inclusive; defaults to the last 7 days
  getDailyCalls: ({projectId, start, end, filters, signal}) =>
    axios.get(`${base(projectId)}/daily-calls`, {params: toParams(filters, {start, end}), headers: headers(projectId), signal}),
  getStatuses: ({projectId, start, end, filters, signal}) =>
    axios.get(`${base(projectId)}/statuses`, {params: toParams(filters, {start, end}), headers: headers(projectId), signal}),
  getFilters: ({projectId, signal}) =>
    axios.get(`${base(projectId)}/filters`, {headers: headers(projectId), signal}),
};
